import React from "react";

import { useDictionary } from "hooks";

import styles from "../ModelerToolbar.css";


export const InvalidElementsError = ({ invalidElements }) => {
	const dictionary = useDictionary("formDesigner.notifications");

	return (
		<React.Fragment>
			<p>
				{dictionary.invalidElements}
			</p>
			<ul className={styles.invalidElementsList}>
				{invalidElements.map((element, k) => (
					<li key={`invalid-field-description-${k}`}>
						<span>
							<p><b>Section:</b> {element.section}</p>
							<p><b>Question:</b> {element.label}</p>
							<p><b>Issues:</b> {element.issues.join(", ")}</p>
						</span>
					</li>
				))}
			</ul>
		</React.Fragment>
	);
};
